export default "__VITE_ASSET__Bb_10TGz__"